/**
 * Helper function to extract the storage path from a Firebase Storage download URL
 * @param url - The Firebase Storage URL
 * @returns The decoded path, or null if extraction fails
 */
const extractPathFromFirebaseUrl = (url: string): string | null => {
  const regex = /\/o\/([^?]+)\?/;
  const match = url.match(regex);
  if (match && match[1]) {
    // Decode the path and replace encoded '/' (%2F) with real '/'
    return decodeURIComponent(match[1]).replace(/%2F/g, '/');
  }
  return null;
};

/**
 * Extracts the filename from a Firebase Storage URL
 * @param url - The Firebase Storage URL (e.g., "https://firebasestorage.googleapis.com/v0/b/bucket/o/path%2Fto%2Ffile.pdf?alt=media&token=...")
 * @returns The decoded filename, or 'downloaded_file' if extraction fails
 */
const getFirebaseURLFilename = (url: string): string => {
  return extractPathFromFirebaseUrl(url)?.split('/').pop() || 'downloaded_file';
};

export default getFirebaseURLFilename;
